"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ContentWrapper () {
        return _ContentWrapper.ContentWrapper;
    },
    get Footer () {
        return _Footer.Footer;
    },
    get RootWrapper () {
        return _RootWrapper.RootWrapper;
    },
    get getFieldIconUrl () {
        return _iconUrl.getFieldIconUrl;
    }
});
const _ContentWrapper = require("~/services/mail/templates/components/ContentWrapper");
const _Footer = require("~/services/mail/templates/components/Footer");
const _RootWrapper = require("~/services/mail/templates/components/RootWrapper");
const _iconUrl = require("~/services/mail/templates/components/iconUrl");
